<template>
  <div class="capacity-analysis" v-loading="loading">
    <el-card class="card">
      <!-- workOrder_v5 §9-C/D：区间与分组改落点时间/落点组，产能改产能配置（满产×工作日 + 扩充） -->
      <Team
        title="创意团队工作量"
        subTitle="(完成量:制作完成时间，其他:落点时间)"
        :dataList="creative_team_workload"></Team>
    </el-card>
    <el-card class="card">
      <!-- workOrder_v5 §9-A：去「产能剩余」；时间维度本就是指派完成日期，subTitle 改成与口径一致 -->
      <People
        title="制作人员工作量"
        subTitle="(指派完成日期)"
        :dataList="producer_workload"></People>
    </el-card>
    <el-card class="card">
      <TeamStatus :dataList="team_demand"></TeamStatus>
    </el-card>
    <!-- workOrder_v5 §8：素材分类标签分布由原文饼图改为一～四级横向柱状图（后端 material_label 出参 {lv1..lv4}），
         2026-10-19 测试反馈：由「一张卡片内 2×2」改为「一~四级各一张卡片」，四张卡 50% 宽 2×2 排布 -->
    <el-card v-for="lv in labelLevels" :key="lv.key" class="card card-half">
      <LevelBarChart
        :level="lv.key"
        :levelLabel="lv.label"
        title="素材分类标签分布"
        subTitle="(素材上传时间)"
        :dataList="material_label">
      </LevelBarChart>
    </el-card>
    <el-card class="card" v-if="false"> </el-card>
    <el-card class="card" v-if="false"> </el-card>
  </div>
</template>
<script>
import { debounce } from "lodash"
import LevelBarChart from "./LevelBarChart.vue"
import People from "./People.vue"
import Team from "./Team.vue"
import TeamStatus from "./TeamStatus.vue"
import API from "@/api/workOrder/board.js"

export default {
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    LevelBarChart,
    Team,
    People,
    TeamStatus,
  },
  data() {
    return {
      loading: false,
      creative_team_workload: [], // 创意团队工作量
      producer_workload: [], // 制作人员工作量
      team_demand: [], // 团队需求情况
      material_label: {}, // 素材分类标签分布 {lv1:[{name,num}],lv2,lv3,lv4}（v5 §8）
      // v5 §8 测试反馈：一~四级各一张卡片
      labelLevels: [
        { key: "lv1", label: "一级" },
        { key: "lv2", label: "二级" },
        { key: "lv3", label: "三级" },
        { key: "lv4", label: "四级" },
      ],
      // teamData: [
      //   {
      //     value: [80, 60, 70, 30, 85],
      //     name: "创意一组",
      //     symbol: "circle",
      //     symbolSize: 8,
      //     lineStyle: {
      //       color: "#557fee",
      //       width: 2,
      //     },
      //     itemStyle: {
      //       color: "#557fee",
      //     },
      //     areaStyle: {
      //       color: "rgba(85, 127, 238, 0.2)",
      //     },
      //   },
      //   {
      //     value: [75, 65, 60, 25, 80],
      //     name: "创意二组",
      //     symbol: "circle",
      //     symbolSize: 8,
      //     lineStyle: {
      //       color: "#53b686",
      //       width: 2,
      //     },
      //     itemStyle: {
      //       color: "#53b686",
      //     },
      //     areaStyle: {
      //       color: "rgba(83, 182, 134, 0.2)",
      //     },
      //   },
      //   {
      //     value: [65, 70, 75, 40, 70],
      //     name: "创意三组",
      //     symbol: "circle",
      //     symbolSize: 8,
      //     lineStyle: {
      //       color: "#e8a33b",
      //       width: 2,
      //     },
      //     itemStyle: {
      //       color: "#e8a33b",
      //     },
      //     areaStyle: {
      //       color: "rgba(232, 163, 59, 0.2)",
      //     },
      //   },
      //   {
      //     value: [70, 55, 65, 35, 75],
      //     name: "视频组",
      //     symbol: "circle",
      //     symbolSize: 8,
      //     lineStyle: {
      //       color: "#dd554b",
      //       width: 2,
      //     },
      //     itemStyle: {
      //       color: "#dd554b",
      //     },
      //     areaStyle: {
      //       color: "rgba(221, 85, 75, 0.2)",
      //     },
      //   },
      //   {
      //     value: [85, 50, 60, 20, 90],
      //     name: "平面组",
      //     symbol: "circle",
      //     symbolSize: 8,
      //     lineStyle: {
      //       color: "#885ded",
      //       width: 2,
      //     },
      //     itemStyle: {
      //       color: "#885ded",
      //     },
      //     areaStyle: {
      //       color: "rgba(136, 93, 237, 0.2)",
      //     },
      //   },
      // ],

    }
  },
  watch: {
    form: {
      handler: debounce(function (newVal, oldVal) {
        this.loading = true
        let params = {
          ...this.form,
          range_time:
            this.form.range_time?.length > 0
              ? this.form?.range_time.join("/")
              : "",
        }
        API.getCapacityAnalysis(params).then((res) => {
          if (res.code === 200) {
            this.loading = false
            this.creative_team_workload = res.data.creative_team_workload
            this.producer_workload = res.data.producer_workload
            this.team_demand = res.data.team_demand.map((item) => {
              return {
                name: item.name,
                value: [
                  Number(item.on_time_completion_rate.replaceAll("%", "")), // 按时完成率
                  Number(item.through_rate.replaceAll("%", "")), // 通过率
                  Number(item.refusal_rate.replaceAll("%", "")), // 拒绝率
                  Number(item.demand_num_rate.replaceAll("%", "")), //  需求量占比
                  Number(item.overdue_rate.replaceAll("%", "")), // 工单超时率
                ],
              }
            })
            // v5 §8：后端已是 {lv1..lv4:[{name,num}]} 结构，直接赋值；老结构（数组）兜底为空对象
            const ml = res.data.material_label
            this.material_label = ml && !Array.isArray(ml) ? ml : {}
          }
        })
      },500),
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped lang="scss">
.capacity-analysis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  .card {
    width: 33%;
    margin-bottom: 20px;
  }
  // v5 §8：素材分类标签分布四张卡片 50% 宽，排成 2×2
  .card-half {
    width: 49%;
  }
  ::v-deep(.el-card__header) {
    border-bottom: 0 !important;
    padding: 15px;
  }
  ::v-deep(.el-card__body) {
    padding: 16px;
  }
}
</style>
